import { centroid } from '@turf/turf';
import { MapComponent } from 'src/app/components/map/map.component';
// @ts-ignore
import { Marker, LngLat, LngLatLike } from '!mapbox-gl';
import { SLLayer } from '../sl-layer';
import { Subscription } from 'rxjs';
import { MapApiService } from '../api-services/map-api.service';
import { ResultsViewComponent } from 'src/app/components/results-view/results-view.component';
import { SearchParams, BBOXArray } from 'src/app/types/@types/sl-v-types';
import { PixoSpatialCoord } from '../Pixospatial';
import { BufferSrc } from '../buffersrc';
import { ResultContext, ResultMoment } from 'src/app/services/results.service';
import { ResultHistory } from '../result-history';
import { EditorAction } from './editor-action';
import { LayerAttributeViewComponent } from 'src/app/components/layer-attribute-view/layer-attribute-view.component';
import { LayerAttributesViewComponent } from 'src/app/components/layer-attributes-view/layer-attributes-view.component';
import { LayersViewComponent } from 'src/app/components/layers-view/layers-view.component';
import { SLContext } from 'src/app/types/sl-context';
import { ActionMap, ActionHandlerService } from 'src/app/services/action-handler.service';
import { ButtonComponent } from 'src/app/components/button/button.component';
import { Key } from 'protractor';
import { PUCManager } from 'src/app/components/p-u-c/p-u-c-manager';
import { LngLatBounds } from 'mapbox-gl';
import { SLMap } from '../sl-map';
import { AttEditorComponent } from 'src/app/components/attribute-view/att-editor/att-editor.component';

export type InfoQueryParams = {
  mapPt: LngLat,
  layer: Array<string | number>,
  bufferSr?: BufferSrc,
  buffer?: BufferSrc
  visOnly: boolean
}

export class InfoAction {
  public static infoMarker: Marker;
  public static buffer = 0;
  public static bufferSrc: BufferSrc = new BufferSrc(0, 'ft');
  public static markerSubscriptions: Array<Subscription> = [];

  public static Exec(command: string, map: MapComponent, data: any) {
    data = data as InfoQueryParams;
    switch (command) {
      case 'query':

        // const layers = (data.layers) ? data.layers : null;
        if (!data.buffer) {
          data.bufferSrc = InfoAction.bufferSrc;
        } else {
          data.bufferSrc = data.buffer;
        }
        if (map.SLMap.src.hasOwnProperty('hasUniversalVis') && map.SLMap.src.hasUniversalVis === true) {
          data.visOnly = map.queryAllSearchableLayers === false;
        }
        if (!data.mapPoint) {
          data.mapPoint = map.SLMap.ui.getCenter();
        }
        const qPromise = map.layersAPI.QueryLayers(map.SLMap, data.mapPoint, data.layers, Infinity, data.bufferSrc, 'false',
          null, null, false, data.visOnly);
        let context: ResultContext = 'query';
        if (!!qPromise.params.memoryLayer) {
          if (!!qPromise.params.gids) {
            if (qPromise.params.gids !== '') {
              context = 'query-by-feature';
            }
          }
        }
        qPromise.promise.then(
          (result) => {
            InfoAction.Exec('map data/show-info', map, {});

            map.SLMap.resultsService.SetResults(
              result,
              context,
              qPromise.params,
              'query',
              data.bufferSrc,
              true,
              ResultHistory.LATEST_ID
            );
            // map.SLMap.ShowQueryResults(result, true, { layers: data.layers, bufferSrc: InfoAction.bufferSrc });

          }).catch((reason) => {
            map.SLMap.messager.Notify('There was an unknown problem performing the requested search', true, 'Problem retrieving features');
          });
        break;
      case 'query-by-feature':
        InfoAction.FeatureQuery(map, data);
        break;
      case 'roi-query':

        InfoAction.ROIQuery(map, data);
        break;
      case 'gps-query':
        InfoAction.GPSQuery(map);
        break;
      case 'gps-query-vis':
        InfoAction.GPSQueryVis(map);
        break;
      case 'hold-start':
        InfoAction.HoldStart(map, data);
        break;
      case 'held':
        InfoAction.Held(map, data);
        break;
      case 'hold-stop':
        InfoAction.HoldStop(map, data);
        break;
      case 'set-buffer':
        if (!!data.bufferSrc) {
          InfoAction.bufferSrc = data.bufferSrc;
        }
        break;
      case 'show-tooltip':
        InfoAction.ShowTooltip(map, data);
        break;
      case 'show-query-results':
        map.SLMap.ShowQueryInResults(data.result);
        break;
      case 'get-results-view-results':
        InfoAction.GetResultsViewResults(map, data);
        break;
      case 'query-mode-toggle':
        {
          const isIt = map.queryAllSearchableLayers ? !map.IsInteracting('querying') : !map.IsInteracting('queryingVis')
          map.QueryModeNone();
          if (map.queryAllSearchableLayers) {
            map.ToggleInteraction('querying', isIt);
          } else {
            map.ToggleInteraction('queryingVis', isIt)
          }
          if (map.SLMap.src.UpdateQueryButtons) {
            map.SLMap.src.UpdateQueryButtons();
          }
        }
        break;

      case 'query-modes-vis-toggle':

        map.queryAllSearchableLayers = !map.queryAllSearchableLayers;
        window.requestAnimationFrame(() => {
          if (map.SLMap.src?.RefreshAllVisButton) {
            map.SLMap.src?.RefreshAllVisButton(!map.queryAllSearchableLayers, false);
          }
        })
        break;
      case 'query-mode-none':
        InfoAction.QueryModeNone(map, data);
        break;
      case 'query-vis-mode-toggle':
        const isIt = !map.IsInteracting('queryingVis');
        map.QueryModeNone();
        map.ToggleInteraction('queryingVis', isIt);
        if (map.SLMap.src.UpdateQueryButtons) {
          map.SLMap.src.UpdateQueryButtons();
        }
        break;

      case 'roi-toggle':
        {
          const isIt = map.queryAllSearchableLayers ? !map.IsInteracting('roiQuerying') : !map.IsInteracting('roiQueryingVis')
          // map.ToggleInteraction('tooltipping');
          map.QueryModeNone();
          if (map.queryAllSearchableLayers) {
            map.ToggleInteraction('roiQuerying', isIt);
          } else {
            map.ToggleInteraction('roiQueryingVis', isIt)
          }
          if (map.SLMap.src.UpdateQueryButtons) {
            map.SLMap.src.UpdateQueryButtons();
          }
        }
        if (map.SLMap.src.UpdateQueryButtons) {
          map.SLMap.src.UpdateQueryButtons();
        }

        break;
      case 'roi-vis-toggle':
        {
          const isIt = !map.IsInteracting('roiQueryingVis')
          // map.ToggleInteraction('tooltipping');
          map.QueryModeNone();
          map.ToggleInteraction('roiQueryingVis', isIt)
          if (map.SLMap.src.UpdateQueryButtons) {
            map.SLMap.src.UpdateQueryButtons();
          }
        }
        if (map.SLMap.src.UpdateQueryButtons) {
          map.SLMap.src.UpdateQueryButtons();
        }
        break;
      case 'hovertip-toggle':
        map.ToggleInteraction('hovertipping');
        break;
      case 'zoom-to-features':
        const svc: MapApiService = map.SLMap.src.mapAPIService as MapApiService;
        svc.GetFeaturesExtent(data.layer, data.features).then((result) => {
          console.log('Zoom to features result', result);
          if (result.bbox) {
            const layer = map.SLMap.GetLayerById(data.layer);
            if ((data.features.length === 1) && (layer.geom === 'point')) {
              const bounds: LngLatBounds = map.layerAPI.LayerExtsToLngLatBounds(result.bbox.split(','));
              const zoomPoint = bounds.getCenter();
              const zoom = Math.max(SLMap.POINT_ZOOM, map.SLMap.ui.getZoom())
              map.SLMap.ui.jumpTo({ zoom, center: zoomPoint })
              return;
            }
            const fitParams = {};// { padding: SLMap.ZOOM_PADDING };
            map.SLMap.ui.fitBounds(map.layerAPI.LayerExtsToLngLatBounds(result.bbox.split(',')), fitParams);
          }
        });
        break;
      case 'roi-sel':
        InfoAction.ROISel(map, data);

        break;
      case 'roi-desel':
        InfoAction.ROIDesel(map, data);
        break;
      case 'sel-add':
        InfoAction.AddToSelection(map, data);
        break;
      case 'sel-unsel':
        InfoAction.RemoveFromSelection(map, data);
        break;
      case 'feature-edit':
        InfoAction.FeatureEdit(map, data);
        break;
      case 'view-attributes':
        InfoAction.ViewAttributes(map, data);
        break;
      case 'get-added-feature':
        InfoAction.GetAddedFeature(map, data);
        break;
      case 'buffer-toggle':
        InfoAction.BufferToggle(map);
        break;
    }
  }
  public static RegisterActions(actions: ActionMap): ActionMap {
    actions['info/buffer-toggle'] = {
      name: 'Toggle global buffer input',
      handler: (context: SLContext, ...args: any) => {
        if (!!args && args.length > 0 && args[0].src === 'key') {
          (context as any).bufferVis = !(context as any).bufferVis;
        }
        InfoAction.BufferToggle(context.map.component);
      },
      keys: {
        key: 'b',
        ctrl: true
      },
      trigger: 'press'
    }
    actions['info/query-modes-vis-toggle'] = {
      name: 'Toggle whether to only query visible layers (on) or all searchable layers (off)',
      handler: (context: SLContext, ...args: any) => {
        InfoAction.Exec('query-modes-vis-toggle', context.map.component, {});
        if (!!args.src && args.src === 'key') {
          if (!!context.RefreshAllVisButton) {
            context.RefreshAllVisButton(!context.map.component.queryAllSearchableLayers, false);
          }
        }
      },
      keys: {
        ctrl: false,
        shift: false,
        key: 'v',
      },
      trigger: 'press'
    }
    actions['info/query-mode-toggle'] = {
      name: 'Toggle Query Point Mode',
      handler: (context: SLContext, ..._args: any) => {
        InfoAction.Exec('query-mode-toggle', context.map.component, {});
      },
      keys: {
        ctrl: false,
        key: 'q',
      },
      trigger: 'press'
    }
    actions['info/query-mode-none'] = {
      name: 'Toggle Pan-only Mode',
      handler: (context: SLContext, ..._args: any) => {
        InfoAction.Exec('query-mode-none', context.map.component, _args);
        /*context.map.component.ToggleInteraction('roiQuerying', false);
        context.map.component.ToggleInteraction('roiQueryingVis', false);
        context.map.component.ToggleInteraction('querying', false);
        context.map.component.ToggleInteraction('queryingVis', false);
        if (_args[0].actionsSvc) {
          const button: ButtonComponent = (_args[0].actionsSvc as ActionHandlerService).GetNamedButton('queryNone-toggle') as ButtonComponent;
          button.Toggle(true, true);
        }
        if (context.map.src.UpdateQueryButtons) {
          context.map.src.UpdateQueryButtons();
        }*/
      },
      keys: {
        shift: true,
        ctrl: true,
        key: 'q'
      },
      trigger: 'press'
    }
    actions['info/roi-toggle'] = {
      name: 'Toggle Query by ROI (Region of Interest); a rectangular area',
      handler: (context: SLContext, ..._args: any) => {
        InfoAction.Exec('roi-toggle', context.map.component, {});
      },
      keys: {
        ctrl: false,
        shift: true,
        key: 'q',
      },
      trigger: 'press'
    }
    actions['info/gps-query'] = {
      name: 'Query via GPS location',
      handler: (context: SLContext, ..._args: any) => {
        if (context.map.component.queryAllSearchableLayers === true) {
          InfoAction.GPSQuery(context.map.component);
        } else {
          InfoAction.GPSQueryVis(context.map.component);
        }
      },
      keys: {
        ctrl: true,
        shift: true,
        key: 'g',
      },
      trigger: 'press'
    }
    actions['info/memory-restore'] = {
      name: 'Restore memory results',
      handler: (context: SLContext, ..._args: any) => {
        InfoAction.MemoryRestore(context.map.component, {});
      },
      keys: {
        ctrl: true,
        key: 'm',
      },
      trigger: 'press'
    }
    actions['info/memory-query'] = {
      name: 'Restore memory results',
      handler: (context: SLContext, ..._args: any) => {
        if (context.map.component.queryAllSearchableLayers === true) {
          InfoAction.MemoryQuery(context.map.component, {});
        } else {
          InfoAction.MemoryQueryVis(context.map.component, {});
        }
      },
      keys: {
        ctrl: true,
        shift: true,
        key: 'm',
      },
      trigger: 'press'
    }
    actions['info/click-map'] = {
      name: 'Query at Map Center',
      handler: (context: SLContext, ..._args: any) => {
        this.ClickMapCenter(context.map.component);
      },
      trigger: 'press'
    }
    actions['info/hovertip-toggle'] = {
      name: 'Toggle Hover-tip Tool',
      handler: (context: SLContext, ..._args: any) => {
        context.map.component.ToggleInteraction('hovertipping');
        if ((context as any).GetButton) {
          const button = (context as any).GetButton('hovertip-toggle');
          if (button !== false) {
            (button as ButtonComponent).Toggle(context.map.component.IsInteracting('hovertipping'), false);
          }
        }
      },
      keys: {
        key: 't'
      },
      trigger: 'press'
    }
    actions['info/memory-clear'] = {
      name: 'Clear Memory Results',
      handler: (context: SLContext, ..._args: any) => {
        if (context.map.component.queryAllSearchableLayers === true) {
          InfoAction.MemoryQuery(context.map.component, {});
        } else {
          InfoAction.MemoryQueryVis(context.map.component, {});
        }
      }

    }
    actions['info/refresh-results-layer'] = {
      name: 'Refresh Results Layer',
      handler: (context: SLContext, ...args: any) => {
        this.RefreshResultsLayer(context.map.component, args[0]);
      }
    }
    return actions;
  }
  static HoldStart(map: MapComponent, info: any) {
    console.log('info marker', info.marker);
    if (!info.marker) { return; }
    if (map.isHolding === false) { return; }

    $(info.marker).toggleClass('info-location', true);
    $(info.marker)[0].src = map.SLMap.environmentService.baseHRef + 'assets/images/pie_point.png';
    setTimeout(() => { $(info.marker).toggleClass('holding', true); }, 50);


    // $(info.marker).toggleClass('info-holding', true);
  }
  static Held(map: MapComponent, info: any) {
    if (!info.marker) { return; }
    if ($(info.marker)[0].src !== map.SLMap.environmentService.baseHRef + 'assets/images/location.png') {
      $(info.marker).toggleClass('info-location', true);
      $(info.marker)[0].src = map.SLMap.environmentService.baseHRef + 'assets/images/location.png';
      $(info.marker).toggleClass('holding', false);
    }

  }
  static HoldStop(map: MapComponent, info: any) {
    if (!info.marker) { return; }
    // if (!map.component.isHolding) { return; }
    if ($(info.marker)[0].src !== map.SLMap.environmentService.baseHRef + 'assets/images/location.png') {
      $(info.marker).toggleClass('info-location', true);
      $(info.marker)[0].src = map.SLMap.environmentService.baseHRef + 'assets/images/location.png';

      // $(info.marker).toggleClass('info-holding', false);
    }
    $(info.marker).toggleClass('holding', false);
    // $(info.marker).toggleClass('info-holding', false);
  }
  static ShowTooltip(map: MapComponent, info: any) {
    const results = info.result;
    if (!!results.resultSet) {
      map.PUCMan.ShowResults(results);
      return;
    }
    if (results.length > 0) {
      const isPLayer: boolean = !!map.SLMap.project;
      const layer: SLLayer | null = map.SLMap.GetLayerById(isPLayer ? results[0].plid : results[0].layer, isPLayer);
      if ((layer as SLLayer) === null) {
        return;
      }
      if ((layer as SLLayer) === undefined) {
        return;
      }
      // const tooltipText: string = layer.GetTooltipText(results[0].features[0]);

      if (!!map.PUCMan) {
        // ToDo: handler to show results?;
        // (map.PUCMan as PUCManager).ShowResults({ results: (results) });
      } else {
        map.SLMap.ShowQueryInResults({ results: (results) });
        return;
      }
      /*
      if (!!map.infoMarker) {
        if ((map.infoMarker as Marker).getPopup()) {
          if (map.infoMarker.getPopup().isOpen()) {
            map.infoMarker.togglePopup();
          }
        }
        const popup = new Popup({ closeOnClick: false, className: 'sl-result-popup' });
        (map.infoMarker as Marker).setPopup(popup);
        if (InfoAction.markerSubscriptions.length > 0) {
          for (const sub of InfoAction.markerSubscriptions) {
            sub.unsubscribe();
          }
        }
        const content = map.dynComponentSvc.injectComponent(ResultPopupComponent,
          (x) => {
            x.SetResults(map.SLMap, map.layerAPI, results);
            InfoAction.markerSubscriptions.push(x.actions.subscribe((event: any) => {
              switch (event.action) {
                case 'show-in-features':
                  // ToDo: Show in features;
                  break;
                case 'close':
                  if (map.infoMarker.getPopup().isOpen()) {
                    map.infoMarker.togglePopup();
                  }
                  break;
              }
            }));
            x.actions.subscribe((event) => {
              if (event.action === 'close') {
                map.SLMap.resultPopupContent = null;
              }
            });
            map.SLMap.resultPopupContent = x;
          });
        popup.setDOMContent(content);
        // popup.setHTML(tooltipText);

        if (popup.isOpen() === false) {
          map.infoMarker.togglePopup();
        }


      }
      */

    }
  }
  static GetResultsViewResults(map: MapComponent, args: any) {
    if (!!map.SLMap.src.resultsView) {
      const results = (map.SLMap.src.resultsView as ResultsViewComponent).GetResults();
      if (!!args.callBack) {
        args.callBack({ results: (results) });
      } else {
        return results;
      }
    } else {
      if (!!args.callBack) {
        args.callBack({ results: [] });
      } else {
        return { results: [] };
      }
    }
  }
  static ShowQueryResults(map: MapComponent, args: any): void {
    const data = args.result;
    /* if (!!map.SLMap.src.resultsView) {
      (map.SLMap.src.resultsView as ResultsViewComponent).ShowResults(
        data.results,
        data.selectedLayer.id,
        data.selectedFeature
      );
    }
    */
    map.SLMap.resultPopupContent.SetResults(map.SLMap, map.SLMap.resultsService, data);

    alert('showing query results');
  }
  static SetupButtons(map: MapComponent): void {
    map = map;
  }

  static AddToSelection(map: MapComponent, data: any): void {
    const layer = map.SLMap.GetSearchLayer();
    if (!!layer) {
      const layers = [layer];
      const qPromise = map.layersAPI.QueryLayers(map.SLMap, data.result.lngLat, layers, Infinity, null, 'false');
      qPromise.promise.then(
        (result) => {
          if (result.results.length > 0) {
            map.SLMap.AppendResults(result.results[0].features);
          }
        });
    }

  }
  static RemoveFromSelection(map: MapComponent, data: any): void {
    const layer = map.SLMap.GetSearchLayer();
    if (!!layer) {
      const layers = [layer];
      const qPromise = map.layersAPI.QueryLayers(map.SLMap, data.result.lngLat, layers, Infinity, null, 'false')
      qPromise.promise.then(
        (result) => {
          if (result.results.length > 0) {
            map.SLMap.ExcludeResults(result.results[0].features);
          }
        });
    }

  }
  static ROISel(map: MapComponent, data: any): void {
    const layer = map.SLMap.GetSearchLayer();
    const inFrom: PixoSpatialCoord = data.result.from;
    const inTo: PixoSpatialCoord = data.result.to;
    const from: LngLatLike = inFrom.spatial;
    const to: LngLatLike = inTo.spatial;
    const params: SearchParams = {
      bbox: [
        Math.min(from.lng, to.lng),
        Math.min(from.lat, to.lat),
        Math.max(from.lng, to.lng),
        Math.max(from.lat, to.lat)
      ].join(','),
      buffer: 0,
      count: Infinity,
      idField: 'gid'
    };
    if (layer.isPLayer === true) {
      params.player = layer.identifier;
    } else {
      params.layer = layer.id;
    }
    map.layerAPI.SearchFeatures(params).then((result) => {
      if (result.results.length > 0) {
        map.SLMap.AppendResults(result.results[0].features);
      }
    });
  }
  static ROIDesel(map: MapComponent, data: any): void {
    const layer = map.SLMap.GetSearchLayer();
    const inFrom: PixoSpatialCoord = data.result.from;
    const inTo: PixoSpatialCoord = data.result.to;
    const from: LngLatLike = inFrom.spatial;
    const to: LngLatLike = inTo.spatial;
    const params: SearchParams = {
      bbox: [
        Math.min(from.lng, to.lng),
        Math.min(from.lat, to.lat),
        Math.max(from.lng, to.lng),
        Math.max(from.lat, to.lat)
      ].join(','),
      buffer: 0,
      count: Infinity,
      idField: 'gid'
    };
    if (layer.isPLayer === true) {
      params.player = layer.identifier;
    } else {
      params.layer = layer.id;
    }
    map.layerAPI.SearchFeatures(params).then((result) => {
      if (result.results.length > 0) {
        map.SLMap.ExcludeResults(result.results[0].features);
      }
    });
  }
  static ClickMapCenter(map: MapComponent) {
    const pt = map.SLMap.ui.getCenter();
    map.MapClick({ lngLat: pt, point: map.SLMap.ui.project(pt) }, true);
  }
  static GPSQuery(map: MapComponent) {
    if (map.queryAllSearchableLayers === false) {
      InfoAction.GPSQueryVis(map);
      return;
    }

    if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition((info) => {
        const pt: LngLat = new LngLat(info.coords.longitude, info.coords.latitude);
        map.SLMap.ui.jumpTo({ center: pt, zoom: 19, bearing: 0, pitch: 0 })
        map.SLMap.ui.once('idle', () => {
          const simClick = { lngLat: pt, point: map.SLMap.ui.project(pt), queryVis: true };
          map.SetMarker(simClick);
          map.InfoClick(simClick, true)
        })

      }, () => {
        map.SLMap.messager.Notify('Unable to acquire GPS Location. Please try again.')
      }, { enableHighAccuracy: true, timeout: 3000 });
    }
  }
  static GPSQueryVis(map: MapComponent) {
    if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition((info) => {
        const pt: LngLat = new LngLat(info.coords.longitude, info.coords.latitude);
        map.SLMap.ui.jumpTo({ center: pt, zoom: 19, bearing: 0, pitch: 0 })
        map.SLMap.ui.once('idle', () => {
          const simClick = { lngLat: pt, point: map.SLMap.ui.project(pt), queryVis: true };
          map.SetMarker(simClick);
          map.InfoClick(simClick, true)
        })


      }, () => { map.SLMap.messager.Notify('Unable to acquire GPS Location. Please try again.') }, { enableHighAccuracy: true, timeout: 3000 });
    }
  }

  public static FeatureEdit(map: MapComponent, data: any) {
    /*if (!!map.SLMap.src.attributeView) {
      map.SLMap.src.attributeView.SetEditLayer(data.layer);
    }*/
    if (map.SLMap.src.hasOwnProperty('layerSel')) {
      map.SLMap.src.layerSel.SetLayer(data.layer);
    }

    /*
    if (map.SLMap.src.hasOwnProperty('toolSet')) {
      map.SLMap.src.toolSet.SetActiveByName('Editor');
    }
    // map.HandleToolAction({ action: 'tools/editor' });

    //if (map.SLMap.src.hasOwnProperty('toolSet')) {
      map.SLMap.src.toolSet.SetActiveByName('Map Data');
    }
    //
    */

    map.drawPane.ShowFeature(data, () => {
      data.edit = 'geom';
      EditorAction.ShowEditor(map, data);
      if (!!map.SLMap.src.secondaryViews) {
        // map.SLMap.src.secondaryViews.SetView('attribute');
        if (!!map.SLMap.src.attributeView) {
          map.SLMap.src.attributeView.SetEditFeature(map.SLMap, data);
        }
      }
    }, true)



  }
  public static ViewAttributes(map: MapComponent, data: any) {
    const resultsView: ResultsViewComponent = map.SLMap.src.resultsView as ResultsViewComponent;
    const featureInfo = resultsView.GetResultFeatureInfo(data.gid, data.layer);

    if (!!map.SLMap.src.secondaryViews) {
      map.SLMap.src.secondaryViews.SetView('attribute');
      setTimeout(() => {
        const initView = !!data.view ? data.view : 'info';
        map.SLMap.src.attributeView.ShowFeature(featureInfo, initView);
        if (!!map.SLMap.src.panelSet) {
          map.SLMap.src.panelSet.OpenSecondary();

        }
        /*if (!!map.SLMap.src.panelSet) {
          map.SLMap.src.panelSet.UpdatePanels();
        }*/
      }, 100);
    }
  }
  public static OpenAttributePanel(map: MapComponent, _data?: any) {
    map.SLMap.src.secondaryViews.SetView('attribute');
    if (!!map.SLMap.src.panelSet) {
      map.SLMap.src.panelSet.OpenSecondary();
    }
  }
  public static ReQuery(map: MapComponent, data: any) {
    let moment = data.moment! as ResultMoment;
    switch (moment.context) {
      case 'query':
      case 'query-vis':

      case 'query-by-feature':
      case 'query-by-feature-vis':
      case 'roi-query':
      case 'roi-query-vis':

    }

  }
  public static FeatureQuery(map: MapComponent, data: any) {

    if (!!data.bufferSource) {
      InfoAction.bufferSrc = data.bufferSrc;
    }
    let layers = (data.layers) ? data.layers : null;
    const featureLayer = (!!data.featureLayer) ? data.featureLayer : null;
    const gids = (!!data.gids) ? data.gids : null;
    const exact = (!!data.exact) ? data.exact : false;
    if (map.SLMap.src.hasOwnProperty('hasUniversalVis') && map.SLMap.src.hasUniversalVis === true) {
      if (map.queryAllSearchableLayers === false) {
        data.visOnly = true;
      }
    }
    layers = [];
    for (const layer of map.SLMap.layerListService.GetSearchableLayers(map.SLMap.layers)) {
      if (!!data.visOnly) {
        if (data.visOnly === true) {
          if (layer.layerOn === true) {
            layers.push(layer);
          }
        }
      } else {
        layers.push(layer);
      }
    }
    const qPromise = map.layersAPI.QueryLayers(map.SLMap, data.mapPoint, layers,
      Infinity, InfoAction.bufferSrc, 'false', featureLayer, gids, exact);
    qPromise.promise.then(
      (result) => {

        if (!!result.centroid) {
          map.SetMarker({ lngLat: result.centroid });
          setTimeout(() => {
            map.SLMap.resultsService.SetResults(
              result,
              'query-by-feature',
              qPromise.params,
              'query',
              data.bufferSrc,
              true,
              ResultHistory.LATEST_ID
            );
            const moment = map.SLMap.resultsService.history.latest;
            map.SLMap.ShowQueryResults({ moment: (moment) }, false);
            if (!!data.zoom) {
              map.SLMap.ui.jumpTo({ center: result.centroid });
            }
            // map.SLMap.ShowQueryInResults(result);
          }, 100);

        }


      }).catch((reason) => {
        reason = reason;
        map.SLMap.messager.Notify('There was an unknown problem performing the requested search', true, 'Problem retrieving features');
      });

  }
  public static ROIQuery(map: MapComponent, data: any) {
    map.SLMap.messager.Progress('Submitting query', false, .66, 'Querying for features ...');
    if (map.SLMap.src.hasOwnProperty('hasUniversalVis') && map.SLMap.src.hasUniversalVis === true) {
      data.visOnly = !map.queryAllSearchableLayers;
    }
    const inFrom: PixoSpatialCoord = data.result.from;
    const inTo: PixoSpatialCoord = data.result.to;
    const from: LngLatLike = inFrom.spatial;
    const to: LngLatLike = inTo.spatial;
    const bbox: BBOXArray = [
      Math.min(from.lng, to.lng),
      Math.min(from.lat, to.lat),
      Math.max(from.lng, to.lng),
      Math.max(from.lat, to.lat)
    ];
    const searchLayers: Array<SLLayer> = map.SLMap.layerListService.GetSearchableLayers(map.SLMap.layers);
    const qPromise = map.layersAPI.QueryLayersByBbox(
      map.SLMap, bbox, searchLayers, Infinity, InfoAction.bufferSrc.value, 'false', data.visOnly);
    qPromise.promise.then(
      (result) => {
        map.SLMap.messager.CancelProgress('Querying for features ...');
        map.SLMap.resultsService.SetResults(
          result,
          'roi-query',
          qPromise.params,
          'query',
          data.bufferSrc,
          true,
          ResultHistory.LATEST_ID

        );
        if (!map.SLMap.src.hasUniversalVis) {

          InfoAction.Exec('query-mode-toggle', map, {});
          if (map.SLMap.src.UpdateQueryButtons) {
            map.SLMap.src.UpdateQueryButtons();
          }

          // map.SLMap.ShowQueryInResults(result);

        } else {
          InfoAction.Exec('query-mode-toggle', map, {});

          /*const qButton = map.SLMap.src.GetButton('query-toggle');
           if (qButton) {
             qButton.Click();
             qButton.Toggle(true, false);
             map.DisableROI();
           }*/
        }
      }).catch((reason) => {
        reason = reason;
        map.SLMap.messager.CancelProgress('Querying for features ...');
        map.SLMap.messager.Notify('There was an unknown problem performing the requested search', true, 'Problem retrieving features');
      });
  }
  public static GetAddedFeature(map: MapComponent, data: any) {
    const layer = data.layer;
    const feature = data.feature;
    const gid = feature.gid;
    map.layerAPI.SearchFeatures({
      idField: 'gid',
      player: data.layer.identifier,
      filters: JSON.stringify([{ field: 'gid', compare: '==', value: gid }])

    }).then((searchResponse) => {
      console.log(searchResponse);
      map.SLMap.ShowResults(searchResponse, layer, gid, true);
    });
  }
  public static EditAttributeCasting(map: MapComponent, data: { layer: SLLayer, attribute: string | number, mode: 'display' | 'edit' }) {
    if (!!map.SLMap.src.secondaryViews) {
      map.SLMap.src.primaryViews.SetView('attCastingView');
      const attribute = data.layer.GetAttribute('' + data.attribute);
      (map.SLMap.src.layersView as LayersViewComponent).ShowSLLayer(data.layer);
      (map.SLMap.src.layerAttributesView as LayerAttributesViewComponent).SetLayer(data.layer);
      window.requestAnimationFrame(() => {
        (map.SLMap.src.layerAttributesView as LayerAttributesViewComponent).ShowAttribute(attribute);
        window.requestAnimationFrame(() => {
          (map.SLMap.src.layerAttributeView as LayerAttributeViewComponent).ConfigReportQualifier();
        });
      })
    }
  }
  public static BufferToggle(map: MapComponent) {
    map.SLMap.src.bufferForm.HandleUpdated(map.SLMap.src.bufferVis);
  }
  public static MemoryRestore(map: MapComponent, data: any) {
    data.featureLayer = map.SLMap.memory.layer.id;
    data.gids = map.SLMap.memory.features;
    data.action = 'info/query-by-feature';
    data.layers = [map.SLMap.memory.layer];
    data.context = 'memory-restore';
    data.exact = true;
    InfoAction.FeatureQuery(map, data);

  }
  public static MemoryQuery(map: MapComponent, data: any) {
    if (map.SLMap.src.hasOwnProperty('hasUniversalVis') && map.SLMap.src.hasUniversalVis === true) {
      if (map.queryAllSearchableLayers === false) {
        return InfoAction.MemoryQueryVis(map, data);
      }
    }
    data.layers = map.SLMap.layerListService.GetSearchableLayers(map.SLMap.layers);
    data.featureLayer = map.SLMap.memory.layer.id;
    data.gids = map.SLMap.memory.features;
    data.action = 'info/query-by-feature';
    data.context = 'memory-query';
    InfoAction.FeatureQuery(map, data);

  }
  public static MemoryQueryVis(map: MapComponent, data: any) {
    data.featureLayer = map.SLMap.memory.layer.id;
    data.gids = map.SLMap.memory.features;
    data.action = 'info/query-by-feature';
    data.visOnly = true;
    data.context = 'memory-query-vis';
    InfoAction.FeatureQuery(map, data);

  }
  public static QueryModeNone(map: MapComponent, data: any) {
    map.QueryModeNone();
    // map.ToggleInteraction('roiQuerying', false);
    // map.ToggleInteraction('roiQueryingVis', false);
    // map.ToggleInteraction('querying', false);
    // map.ToggleInteraction('queryingVis', false);
    if (data instanceof Array) {
      if (data.length > 0 && !!data[0].actionsSvc) {
        const button: ButtonComponent = (data[0].actionsSvc as ActionHandlerService).GetNamedButton('queryNone-toggle') as ButtonComponent;
        button.Toggle(true, true);
      }
    }
    if (map.SLMap.src.UpdateQueryButtons) {
      map.SLMap.src.UpdateQueryButtons();
    }

  }
  public static RefreshResultsLayer(map: MapComponent, args) {
    const [layer, record] = args;
    if (!map.SLMap.src.resultsView) return;
    map.SLMap.src.resultsView.ReshowLayer(layer, record);
    let found = 0;
    map.SLMap.layers.every((mapLayer) => {
      if (['sel-results', 'unsel-results'].indexOf(mapLayer.id) > -1) {
        const mapLayerSource = mapLayer?.GetSourceLayer();
        if (!mapLayerSource) return true;
        if (!layer.id) return;
        if (mapLayerSource.id == layer.id) {
          mapLayer?.Render();
        }
        found += 1;
      }
      if (found < 2) return true;
      return false;
    });
  }
  public static SimClick(map: MapComponent, args: any) {
    if (!args) args = {};
    if (!args?.queryVis) {
      args.queryVis = false;
    }
    if (!args.pt) return;
    const simClick = { lngLat: args.pt, point: map.SLMap.ui.project(args.pt), queryVis: args.queryVis };
    map.SetMarker(simClick);
    map.InfoClick(simClick, true)
  }
}
